export const formatDate = (date: Date, locale: string = 'en-US'): string => {
  // Format: Month Day, Year
  return new Date(date).toLocaleDateString(locale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};
